import {LoginComponent} from "./common/components/login.component";
import {AuthenticatedGuard} from "./common/guards/authenticated.guard";
import {UpdateProfileComponent} from "./dashboard/update-profile.component";
import {IndiaElectionComponent} from "./india-election.component";
import {Route} from "@angular/router";
import {NonAuthenticatedGuard} from "./common/guards/non-authenticated.guard";

export const routes: Route[] = [
  {path: '', loadComponent: () => LoginComponent, canActivate: [NonAuthenticatedGuard]},
  {path: 'india-election', loadComponent: () => IndiaElectionComponent},
  {path: 'create-account', loadComponent: () => UpdateProfileComponent, data: {register: 1}},
  {
    canActivate: [AuthenticatedGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    path: 'dashboard',
  },
];
